import React from 'react'
import { Heading , Text} from 'base-ui'
import { PageWrapper } from '../components/PageWrapper'

const Principles = () => {
  return (
    <PageWrapper title="Design Principles">
            <Heading size="h3">Consitency</Heading>
            <Text size="1">Each piece is part of a greater whole and should contribute positively to the system at scale and the experience as a whole. There should be no isolated features or outliers, consistency is key</Text>
            <Heading size="h3">Universality</Heading>
            <Text size="1">Our customers are diverse and our products should reflect it trought welcoming and accessible language</Text>
            <Heading size="h3">Conversational Clarity</Heading>
            <Text size="1">Eliminate ambiguity. Enable people to see, understand, and act with confidence in a friendly manner</Text>
            <Heading size="h3">Efficiency</Heading>
            <Text size="1">Streamline and optimize workflows. Intelligently anticipate needs to help people work better, smarter, and faster.</Text>
            <Heading size="h3">Beauty</Heading>
            <Text size="1">Demonstrate respect for people’s time and attention through thoughtful and elegant craftsmanship.</Text>
    </PageWrapper>
  )
}

export default Principles
